import { Box, Stack, styled } from "@mui/material"
import {
  FeatureFlagName,
  type PharmacyPeriodFilter,
  PurchaseLinkBox,
  PurchaseOtherChannelsDialog,
  SafeApiComponent,
  type SalesCardProps,
  SalesCardV2,
  SalesCardV2StatsAndEvolution,
  getPeriodDateRange,
  purchasesChannelEnum,
  useFeatureFlag,
} from "@pharmupp/p3-front-commons"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { PurchaseOtherCard } from "../../../../Purchases"
import { SummaryInfo } from "../../../../common"
import { useMyPharmacyPurchases } from "../useMyPharmacyPurchases"
import { LineTitle } from "./LineBlock"

// TODO : Change for PharmacyPurchases for "MonOfficineV3"
export const ServiceTurnover = (params: PharmacyPeriodFilter) => {
  return (
    <SafeApiComponent>
      <ServiceTurnoverInner {...params} />
    </SafeApiComponent>
  )
}

const msgConnector = "Dépendant de l’activation des connecteurs sur Digipharmacie"

const ServiceTurnoverInner = (params: PharmacyPeriodFilter) => {
  const [openPurchaseOtherChannelsDialog, setOpenPurchaseOtherChannelsDialog] =
    useState(false)
  const navigate = useNavigate()
  const navigateToChannel = (channelId: string) =>
    navigate(`./canal/${encodeURIComponent(channelId)}`)
  const { get: displayMsgConnector } = useFeatureFlag(
    FeatureFlagName.PHARMACY_PURCHASES_CONNECTOR_MESSAGE,
  )
  const { get: purchasesByLab } = useFeatureFlag(
    FeatureFlagName.PURCHASES_CHANNEL_V2,
  )

  const {
    purchasesSummary: {
      formattedData: { main, others, global },
    },
  } = useMyPharmacyPurchases(params)

  return (
    <Stack direction="column" spacing={3}>
      <LineTitle>Répartition par canal (HT)</LineTitle>
      {displayMsgConnector && <PurchaseLinkBox />}
      <TurnoverContainer>
        {main.channel.length > 0 &&
          main.channel.map((channel) => (
            <SalesCardV2
              key={channel.name}
              title={channel.name}
              period={channel.periodEndDate}
              tooltipMsg={displayMsgConnector ? msgConnector : undefined}
              {...(purchasesByLab
                ? { ...displayByLab({ channelId: channel.id, navigate }) }
                : {
                    ...getCoaliaProps({
                      navigate,
                      ...channel,
                      ...params,
                    }),
                  })}
            >
              <SalesCardV2StatsAndEvolution
                mainStat={channel.purchases.mainStat}
                evol={channel.purchases.evolution}
              />
            </SalesCardV2>
          ))}
        <PurchaseOtherCard
          {...others.purchases}
          periodEndDate={others.periodEndDate}
          onClick={
            others.channel.length > 0
              ? () => setOpenPurchaseOtherChannelsDialog(true)
              : undefined
          }
          tooltipMsg={displayMsgConnector ? msgConnector : undefined}
        />
      </TurnoverContainer>
      <SummaryInfo period={global.periodEndDate} sources={global.sources} />
      {openPurchaseOtherChannelsDialog && (
        <PurchaseOtherChannelsDialog
          onClickClose={() => setOpenPurchaseOtherChannelsDialog(false)}
          Card={
            <PurchaseOtherCard
              {...others.purchases}
              periodEndDate={others.periodEndDate}
              tooltipMsg={displayMsgConnector ? msgConnector : undefined}
            />
          }
          channels={others.channel}
          withoutDiscount
          onRowClick={
            purchasesByLab ? (channel) => navigateToChannel(channel.id) : undefined
          }
        />
      )}
    </Stack>
  )
}

const getCoaliaProps = ({
  name,
  period,
  navigate,
}: {
  name: string
  navigate: ReturnType<typeof useNavigate>
} & PharmacyPeriodFilter): Pick<SalesCardProps, "actionLabel" | "onClick"> => {
  if (name !== purchasesChannelEnum.COALIA.label) return {}

  const year = new Date(getPeriodDateRange(period).startDate).getFullYear()

  return {
    onClick: () => navigate(`./coalia/${year}`),
    actionLabel: "Plus de détails",
  }
}

const displayByLab = ({
  navigate,
  channelId,
}: {
  channelId: string
  navigate: ReturnType<typeof useNavigate>
}) => ({
  onClick: () => navigate(`./canal/${encodeURIComponent(channelId)}`),
  actionLabel: "Voir plus",
})

const TurnoverContainer = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(5, 1fr)",
  columnGap: theme.spacing(3),
  rowGap: theme.spacing(2),
  [theme.breakpoints.down("lg")]: {
    gridTemplateColumns: "repeat(4, 1fr)",
  },
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "repeat(3, 1fr)",
  },
}))
